export const teamMembers = [
  {
    id: "team-01",
    name: "青橙",
    role: "内容主编",
    bio: "十年动漫媒体经验，负责资讯选题与深度专栏的把关。",
    avatar:
      "https://readdy.ai/api/search-image?query=Friendly%20stylized%20anime%20style%20avatar%20illustration%20of%20a%20young%20editor%20with%20orange%20short%20hair%20and%20glasses%2C%20clean%20soft%20light%20gray%20background%2C%20simple%20flat%20cel%20shaded%20character%20icon&width=400&height=400&seq=team-01&orientation=squarish"
  },
  {
    id: "team-02",
    name: "白描",
    role: "视觉与作画顾问",
    bio: "多年同人创作经历，负责作画科普与幕后流程拆解内容。",
    avatar:
      "https://readdy.ai/api/search-image?query=Friendly%20stylized%20anime%20style%20avatar%20illustration%20of%20a%20calm%20illustrator%20with%20black%20hair%20and%20a%20sketchbook%2C%20clean%20soft%20light%20gray%20background%2C%20simple%20flat%20cel%20shaded%20character%20icon&width=400&height=400&seq=team-02&orientation=squarish"
  },
  {
    id: "team-03",
    name: "木子",
    role: "社区运营",
    bio: "负责社区话题运营与活动策划，最喜欢和大家聊日常番。",
    avatar:
      "https://readdy.ai/api/search-image?query=Friendly%20stylized%20anime%20style%20avatar%20illustration%20of%20a%20cheerful%20community%20manager%20with%20brown%20ponytail%2C%20clean%20soft%20light%20gray%20background%2C%20simple%20flat%20cel%20shaded%20character%20icon&width=400&height=400&seq=team-03&orientation=squarish"
  },
  {
    id: "team-04",
    name: "岚",
    role: "专栏作者",
    bio: "专注世界观与叙事结构分析，写作风格理性又不失温度。",
    avatar:
      "https://readdy.ai/api/search-image?query=Friendly%20stylized%20anime%20style%20avatar%20illustration%20of%20a%20thoughtful%20writer%20with%20dark%20blue%20hair%2C%20clean%20soft%20light%20gray%20background%2C%20simple%20flat%20cel%20shaded%20character%20icon&width=400&height=400&seq=team-04&orientation=squarish"
  }
];

export const faqList = [
  {
    id: "faq-01",
    question: "漫蛙2 提供在线观看动画的功能吗？",
    answer:
      "不提供。本站是动漫资讯与资料平台，只展示动画的更新信息、集数与简介，帮助大家掌握追番进度。页面中的剧集列表仅用于查看更新状态。"
  },
  {
    id: "faq-02",
    question: "如何快速找到某个角色？",
    answer:
      "进入「角色介绍」页面，使用首字母索引即可快速定位。角色详情页还会展示所属作品、相关资讯与推荐角色，方便你串联浏览。"
  },
  {
    id: "faq-03",
    question: "搜索结果为空怎么办？",
    answer:
      "搜索结果为空时，页面会推荐热门内容。你也可以尝试更短或更常见的关键词，例如作品名、角色名的一部分，或社区话题里的关键词。"
  },
  {
    id: "faq-04",
    question: "社区评论和反馈表单会保存我的数据吗？",
    answer:
      "社区评论为前端演示交互，不会真实保存或提交数据。页面上的反馈表单会通过平台表单服务收集，用于我们改进内容与功能。"
  },
  {
    id: "faq-05",
    question: "页面内容出现错误或打不开怎么办？",
    answer:
      "如果某个资讯或角色页面不存在，页面会显示友好提示并提供返回入口。你也可以通过「帮助与反馈」页面提交问题，我们会尽快核查。"
  },
  {
    id: "faq-06",
    question: "手机上使用体验如何？",
    answer:
      "全站已适配移动端：顶部导航会折叠为菜单，列表与卡片自动调整为单列或两列，详情页内容区域自适应屏幕宽度，保证阅读舒适。"
  }
];

export const usageGuides = [
  {
    id: "guide-01",
    icon: "ri-compass-3-line",
    title: "从首页开始浏览",
    desc: "首页聚合了最新资讯、更新速递、精选角色与社区热点，是了解站点全貌最快的入口。"
  },
  {
    id: "guide-02",
    icon: "ri-search-line",
    title: "用搜索快速定位",
    desc: "顶部搜索框支持资讯标题、角色名与社区话题的关键词搜索，一次覆盖全站内容。"
  },
  {
    id: "guide-03",
    icon: "ri-filter-3-line",
    title: "善用筛选与排序",
    desc: "资讯页与更新页支持按分类、更新时间排序，角色页支持首字母索引，帮助快速缩小范围。"
  },
  {
    id: "guide-04",
    icon: "ri-share-forward-line",
    title: "分享与反馈",
    desc: "资讯详情页可一键复制链接分享；遇到问题或有建议，欢迎在帮助页提交反馈。"
  }
];